module.exports = __webpack_public_path__ + "static/media/audio1.d26a4f60.png";